import * as React from "react";
import ParametroTopo from "./topo";
import { ParametroPortalDetalhe } from "./detalhe";
import { ParametroPortalBottom } from "./bottom";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

export const ParametroPortalPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.portalParameters.title"));

  return (
    <React.Fragment>
      <ParametroPortalDetalhe />
      <ParametroPortalBottom />
    </React.Fragment>
  );
};

export default ParametroPortalPage;